<template>
  <div
    class="linear-activity h-[10px]"
    :class="['loader-bar-'+mode,]"
    :height="height?height:'3px'"
  >
    <div class="indeterminate" />
  </div>
</template>

<script>
export default {
  name: 'ProgressLiner',
  props: {
    mode: {
      type: String,
      default: 'blue'
    },
    height: {
      type: String,
      default: null
    }
  }
}
</script>
<style lang="scss">
/**
* codepen link https://codepen.io/bootpen/pen/WQQLQZ
 */
.linear-activity {
  overflow: hidden;
  position: absolute;
}
.loader-bar{
  &-blue{
    @apply bg-blue-light;

    .indeterminate{
      &:before{
        @apply bg-blue-primary;

      }
      &:after{
        @apply bg-blue-very-light;
      }
    }
  }
  &-yellow{
    @apply bg-yellow-light;

    .indeterminate{
      &:before{
        @apply bg-yellow-primary;

      }
      &:after{
        @apply bg-yellow-very-light;
      }
    }
  }
}

.indeterminate {
  position: relative;
  width: 100%;
  height: 100%;
}

.indeterminate:before {
  content: '';
  position: absolute;
  height: 100%;
  animation: indeterminate_first 1.5s infinite ease-out;
}

.indeterminate:after {
  content: '';
  position: absolute;
  height: 100%;
  animation: indeterminate_second 1.5s infinite ease-in;
}

@keyframes indeterminate_first {
  0% {
    left: -100%;
    width: 100%;
  }
  100% {
    left: 100%;
    width: 10%;
  }
}

@keyframes indeterminate_second {
  0% {
    left: -150%;
    width: 100%;
  }
  100% {
    left: 100%;
    width: 10%;
  }
}
</style>
